import { createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
import axios  from 'config/axios';

import { setAuthenticatedUser,
  setAuthenticationStatus,
  setPromptNewPasswordStatus,
  setAuthenticationDetails,
  setErrors,
  resetAuthData,
  removeTokenData,
  setForgotPasswordStatus,
  setNewPasswordStatus,
  setAuthenticatedRoleStatus,
  setCompanyData,
  setService,
 } from '../../../stores/modules/idp/authreducer'



// Async Thunks
const errorResponse = (response, dispatch) => {
  dispatch(setErrors(response));
};

export const ping = createAsyncThunk('auth/ping', async (login = false, { dispatch }) => {
  dispatch(resetAuthData());
  try {
    const response = await axios.get(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/ping`, {
      _retry: login,
    });
    const resp = response.data;
    dispatch(setAuthenticatedUser(resp));
    dispatch(setAuthenticationStatus(true));
  } catch (error) {
    dispatch(setAuthenticationStatus(false));
    dispatch(errorResponse(error.response,dispatch));
  }
});

export const logout = createAsyncThunk('auth/logout', async ({ dispatch }) => {
  try {
    await axios.put(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/logout`);
    dispatch(resetAuthData());
    dispatch(removeTokenData());
  } catch (error) {
    dispatch(errorResponse(error.response,dispatch));
    dispatch(resetAuthData());
  }
});

export const loginAPIService = createAsyncThunk('auth/login', async (params, { dispatch }) => {
  dispatch(resetAuthData());
  dispatch(setAuthenticatedRoleStatus(null));
  dispatch(setService(''));
  try {
    const response = await axios.post(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/login`, params);

    if (response.data.ChallengeName && response.data.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
      dispatch(setPromptNewPasswordStatus(response.data.Session));
      dispatch(setAuthenticationStatus(false));
    } else {
      const resp = response.data;
      dispatch(setAuthenticatedUser(resp.userData));
      dispatch(setAuthenticationDetails({
        id_token: resp.idToken,
        access_token: resp.token,
        refresh_token: resp.refreshtoken,
      }));
      dispatch(setPromptNewPasswordStatus(false));
      dispatch(setAuthenticationStatus(true));
      // if (resp.userData.roles && resp.userData.roles[0].label==='User' || resp.userData.roles[0].label==='Superuser'
      //      || resp.userData.roles[0].label==='Admin'){
        let obj={};
        obj.companyid=resp.userData.company.id;
        obj.companyname=resp.userData.company.name;
        obj.domain=resp.userData.company.domain;
        obj.soc_group=resp.userData.company.soc_group;
        obj.soc_env=resp.userData.company.soc_env
        dispatch(setCompanyData(obj))
     // }
    }
  } catch (error) {
    dispatch(setAuthenticationStatus(false));
    dispatch(errorResponse(error.response,dispatch));
  }
});

export const refreshToken = createAsyncThunk('auth/refreshToken', async (params, { dispatch }) => {
    try {
      const data = params.params;
      const response = await axios.post(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/refresh`, data);
      const resp = response.data;
      dispatch(setAuthenticationDetails({
        refresh_token: params.refreshtoken,
        id_token: resp.idToken,
        access_token: resp.token,
      }));
    } catch (error) {
      dispatch(setAuthenticationStatus(false));
      dispatch(errorResponse(error.response,dispatch));
    }
  });

export const forgotPasswordRequestService = createAsyncThunk('auth/forgotPasswordRequest', async (params, { dispatch }) => {
  dispatch(setForgotPasswordStatus(null));
  dispatch(setErrors([]));
  try {
    await axios.post(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/forgot-password`, params);
    dispatch(setForgotPasswordStatus(true));
  } catch (error) {
    dispatch(setForgotPasswordStatus(false));
    dispatch(errorResponse(error.response,dispatch));
  }
});

  export const forgotPasswordVerifyService = createAsyncThunk('auth/forgotPasswordVerify', async (params, { dispatch }) => {
    dispatch(setForgotPasswordStatus(null));
    dispatch(setErrors([]));
    try {
      await axios.put(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/reset-password`, params);
      dispatch(setForgotPasswordStatus(true));
    } catch (error) {
      dispatch(setForgotPasswordStatus(false));
      
      dispatch(errorResponse(error.response,dispatch));
    }
  });
  export const confirmNewPasswordService = createAsyncThunk('auth/confirmNewPasswordService', async (params, { dispatch }) => {
    dispatch(setNewPasswordStatus(null));
    dispatch(setErrors([]));
    try {
      await axios.put(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/confirm-new-password`, params);
      dispatch(setNewPasswordStatus(true));
      dispatch(setPromptNewPasswordStatus(false));
    } catch (error) {
      dispatch(setNewPasswordStatus(false));
      
      dispatch(errorResponse(error.response,dispatch));
    }
  });
  export const resetService = createAsyncThunk('auth/reset', async (params, { dispatch }) => {
    dispatch(resetAuthData());
  });
  
  export const resetErrors = createAsyncThunk('auth/resetErrors', async (params, { dispatch }) => {
    dispatch(setErrors([]));
  });

 
  export const updatePassword = async (body) => {
    try {
     let response= await axios.put(`${process.env.REACT_APP_IDP_AUTH_ENDPOINT_URL}/auth/change-password`, body);
       return response;
    } catch (error) {
     return error?.response;
    }
  };


